export const automotiveClassificationTypes = {
  "All Types": 0,
  Used: 1,
  New: 2
} as const;

export type automotiveClassificationTypesValues =
  (typeof automotiveClassificationTypes)[keyof typeof automotiveClassificationTypes];
export type automotiveClassificationTypesLabels =
  keyof typeof automotiveClassificationTypes;
export const automotiveClassificationTypesLabelsList = Object.keys(
  automotiveClassificationTypes
) as automotiveClassificationTypesLabels[];
export const automotiveClassificationTypesValuesList = Object.values(
  automotiveClassificationTypes
) as automotiveClassificationTypesValues[];

export const automotiveClassificationTypesGetValue = (
  value: automotiveClassificationTypesLabels
): automotiveClassificationTypesValues => {
  return automotiveClassificationTypes[value];
};

export const automotiveClassificationTypesGetLabel = (
  value: automotiveClassificationTypesValues
): automotiveClassificationTypesLabels => {
  return automotiveClassificationTypesLabelsList[
    automotiveClassificationTypesValuesList.indexOf(value)
  ];
};
